export const takedaVerifiedCompliance = [
  {
    value: "takedaVerified",
    key: "My email address is a Takeda ID",
  },
];
